import React from 'react';

import { useLogin } from './useLogin';
import { useLogout } from './useLogout';

const DataLayerLoginLogout = () => {
  useLogin();
  useLogout();

  return null;
};

export default React.memo(DataLayerLoginLogout);
